import { useEffect, useRef } from "react";
import { PATH_PICK_SELECTION_BAR_HEIGHT_VAR } from "@/features/pathpick/constants";

// 하단 플로팅 선택 바의 높이를 실측해 CSS 변수에 싣는다 — 목록 끝 여백(PathPickSelectionBarSpacer)이 읽는다.
// 바 높이는 문구·언어·폭(담은 상품은 품절 안내 유무)에 따라 달라 고정값으로 둘 수 없다
// (PWA 설치 배너가 --pwa-banner-height를 싣는 방식과 같다). 반환한 ref를 바 루트에 붙인다.
const usePathPickSelectionBarHeight = <T extends HTMLElement>() => {
  const rootRef = useRef<T | null>(null);

  useEffect(() => {
    const element = rootRef.current;
    if (!element) {
      return;
    }

    const rootStyle = document.documentElement.style;
    const measure = () =>
      rootStyle.setProperty(
        PATH_PICK_SELECTION_BAR_HEIGHT_VAR,
        `${element.getBoundingClientRect().height}px`
      );
    measure();

    // ResizeObserver는 Safari 13.1+ 라서 그 이하에서는 resize 이벤트로만 따라간다.
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => {
        window.removeEventListener("resize", measure);
        rootStyle.removeProperty(PATH_PICK_SELECTION_BAR_HEIGHT_VAR);
      };
    }

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => {
      observer.disconnect();
      rootStyle.removeProperty(PATH_PICK_SELECTION_BAR_HEIGHT_VAR);
    };
  }, []);

  return rootRef;
};

export default usePathPickSelectionBarHeight;
